import { useEffect } from "react"
import { useSpeech } from "../contexts/SpeechContext"
import { useLocalStorage } from "../contexts/LocalStorageContext"
import { Card, Col, Container, Row } from "react-bootstrap"
import { Link } from "react-router-dom"
import Swal from "sweetalert2"

const Home = () => {
  const { config, tasks } = useLocalStorage()
  const { speak } = useSpeech()

  useEffect(() => {
    if (config.enableVoice) {
      let message = 'Bienvenue sur votre programme de lecture de documents. '
      if (tasks.length > 0) {
        message += `Vous avez ${tasks.length} tâches en attente.`
      }
      speak(message)
    }
  }, [config, speak, tasks.length])

  return (
    <>
      <Container>
        <Row className="justify-content-md-center text-center">
          <Col lg={4}>
            <h2 className="my-3">
              Lecture de documents
            </h2>
            <Link to="/ocr" style={{ textDecoration: 'none' }}>
              <Card className="mb-3" style={{ borderRadius: '20px' }}>
                <Card.Body style={{ backgroundColor: 'rgb(34, 197, 94)', color: 'white', borderRadius: '20px' }}>
                  <h1>
                    <i className="bi bi-camera" style={{ fontSize: '1.5em' }}></i>
                  </h1>
                  <h3>
                    Photographier<br />
                    <small style={{ fontSize: '0.7em', fontWeight: 'normal' }}><i>Photographier et lire un document</i></small>
                  </h3>
                </Card.Body>
              </Card>
            </Link>

            <Link to="/asr" style={{ textDecoration: 'none' }}>
              <Card className="mb-3" style={{ borderRadius: '20px' }}>
                <Card.Body style={{ backgroundColor: 'rgb(59, 130, 246)', color: 'white', borderRadius: '20px' }}>
                  <h1>
                    <i className="bi bi-mic" style={{ fontSize: '1.5em' }}></i>
                  </h1>
                  <h3>
                    Parler<br />
                    <small style={{ fontSize: '0.7em', fontWeight: 'normal' }}><i>Discuter avec l'assistant</i></small>
                  </h3>
                </Card.Body>
              </Card>
            </Link>

            <Card className="mb-3" style={{ borderRadius: '20px' }} onClick={() => Swal.fire({icon: 'info', title: 'Bientot disponible'})}>
              <Card.Body style={{ backgroundColor: 'rgb(179, 56, 57)', color: 'white', borderRadius: '20px' }}>
                <h1>
                  <i className="bi bi-list-task" style={{ fontSize: '1.5em' }}></i>
                </h1>
                <h3>
                  Traiter ({tasks.length})<br />
                  <small style={{ fontSize: '0.7em', fontWeight: 'normal' }}><i>Effectuer vos tâches en attente</i></small>
                </h3>
              </Card.Body>
            </Card>

            <Link to="/config" style={{ textDecoration: 'none' }}>
              <Card className="mb-3" style={{ borderRadius: '20px' }}>
                <Card.Body style={{ backgroundColor: 'rgb(70, 71, 134)', color: 'white', borderRadius: '20px' }}>
                  <h1>
                    <i className="bi bi-tools" style={{ fontSize: '1.5em' }}></i>
                  </h1>
                  <h3>
                    Configurer<br />
                    <small style={{ fontSize: '0.7em', fontWeight: 'normal' }}><i>Modifier vos paramètres</i></small>
                  </h3>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Home
